module.exports = __webpack_public_path__ + "img/lich-tot-xau-icon.4935ea6d.png";